/**
 * 8비트 도트 팔레트. 색만으로 전달되는 정보는 0개다 — 모든 구분은 형태로 중복 부호화된다.
 * ADR-008: 글자 타일은 정답·오답 구분 없이 전부 TILE / TILE_INK 한 벌만 쓴다.
 */
export const PALETTE = {
  VOID: '#0A0812',
  FIELD: '#16131F',
  FIELD_WARN: '#38192A',
  FIELD_DOT: '#2E2848',
  DOT_WARN: '#4A2338',
  WALL: '#5B5490',
  WALL_TOP: '#7C74B0',
  HEAD: '#FF8A3D',
  BODY_A: '#D9531F',
  BODY_B: '#AE4419',
  TILE: '#E4E0F2',
  TILE_EDGE: '#9C96BE',
  TILE_INK: '#14111E',
  GOOD: '#5CD97A',
  BAD: '#FF4D6D',
  ACCENT: '#FFD447',
  NEUTRAL: '#A29CC4',
  HINT: '#4FC3E8',
  UI_BG: '#1B1829',
  UI_LINE: '#332E4E',
  INK: '#F2EFFF',
  INK_DIM: '#A29CC4',

  // ── 봉인 프레젠테이션 ─────────────────────────────────────────────
  // 압박 링. 티어는 두께(t/2 → t)와 맥동으로도 부호화되므로 색은 2차 신호다.
  SEAL_CALM: '#5FB79A',
  SEAL_WARN: '#FFD447',
  SEAL_CRIT: '#FF4D6D',
  // 단어 완성 직후 감속 구간 — 바닥이 차갑게 가라앉는다(페널티의 붉은 바닥과 반대 방향)
  FIELD_CALM: '#131C22',
  DOT_CALM: '#2F5560',
  // 봉인 성공 — 도트가 통째로 GOOD 계열로 넘어간다
  FIELD_SEAL: '#122018',
  DOT_SEAL: '#356B47',
  // 사망 포켓 틴트 — "네게 남아 있던 방". 붉은 계열로 칠했더니 BAD 로 점멸하는 뱀과
  // 붙어서 형/지 분리가 안 됐다(눈검사 실측). 차가운 계열로 빼서 뱀만 붉게 남긴다.
  // 반투명 대신 불투명 고정색이라 기기별 합성 차이가 없다.
  POCKET: '#243B52',
} as const;

export type PaletteKey = keyof typeof PALETTE;

function srgb(c: number): number {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}

export function luminance(hex: string): number {
  const n = Number.parseInt(hex.slice(1), 16);
  return 0.2126 * srgb((n >> 16) & 255) + 0.7152 * srgb((n >> 8) & 255) + 0.0722 * srgb(n & 255);
}

export function contrast(a: string, b: string): number {
  const la = luminance(a);
  const lb = luminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
